<template>
    <div v-cloak>
        <div class="page-smart-city-wrap">
            <PagesPublicHeader :active="bannar_type" :lng="lng" :lang="lang"></PagesPublicHeader>
            <div class="smart-city-area" v-if="tab === '1' && sub === '11'">
                <div class="info-case1">
                    <div class="info-inner">
                        <div style="height: 55vw;"></div>
                    </div>
                </div>
            </div>
            <PagesPublicFooter :lng="lng" :lang="lang"></PagesPublicFooter>
        </div>
    </div>
</template>

<script>
import { PagesPublicFooter } from "#components";
import langObj from "@/utils/lang";
export default {
    computed: {
        bannar_type() {
            return 'smart-city'
        },
        lng() {
            return langObj[this.lang] || langObj['zh']
        }
    },
    props: {
        tab: {
            default: '1'
        },
        sub: {
            default: '11'
        },
        lang: {
            type: String,
            default: 'zh'
        }
    },
    methods: {
    },
    data() {
        return {
            tab1: '1'
        }
    },
    created() {
        if (typeof window !== 'undefined') {
            // container.classList.remove('lang_zh');
            // container.classList.remove('lang_en');
            // container.classList.add(`lang_${this.lang}`);
        }
    }
}
</script>
<style lang="scss">
.mobile-layout {
    .smart-city-area {
        .info-case1 {}
    }
}

.smart-city-area {
    .info-case1 {}
}
</style>